export const ResourceTypes = Object.freeze({
  URL: 'URLResource',
  ASSESSMENT: 'AssessmentResource',
  QUESTION_BANK: 'QuestionBankResource',
  QUESTION_BANK_BI: 'QuestionBankBIResource',
  TEACHER_MODULE: 'TeacherModuleResource',
  PRACTICE_QUESTIONS: 'PracticeQuestionsResource',
  PROFESSIONAL_LEARNING: 'ProfessionalLearningLinkResource',
  YOUTUBE: 'YoutubeResource',
  PARTNER_LINK: 'PartnerLinkResource',
  DISTANCE_LINK: 'DistanceLinkResource',
  GROUP: 'GroupResource',
  PERFORMANCE_TASK: 'PerformanceTaskResource',
  EMBEDDED_VIDEO: 'EmbeddedVideoResource',
  EBOOK: 'EBookResource',
  SPP: 'StudentPracticeResource',
  SOURCE: 'SourceResource',
  LTI: 'LTIResource',
});

const WL_RESOURCE_IDS = {
  WL_PRACTICE_ACTIVITY: 'WL_PRACTICE_ACTIVITY',
  WL_PRESENTATION_ACTIVITY: 'WL_PRESENTATION_ACTIVITY',
  WL_CONVERSATION_ACTIVITY: 'WL_CONVERSATION_ACTIVITY',
  WL_PRACTICE_PRESENTATION_ACTIVITY: 'WL_PRACTICE_PRESENTATION_ACTIVITY',
  WL_PRACTICE_PRESENTATION_ACTIVITY_2: 'WL_PRACTICE_PRESENTATION_ACTIVITY_2',
  WL_PRACTICE_CONVERSATION_ACTIVITY: 'WL_PRACTICE_CONVERSATION_ACTIVITY',
  WL_PRACTICE_CONVERSATION_ACTIVITY_2: 'WL_PRACTICE_CONVERSATION_ACTIVITY_2',
  WL_PRESENTATION_ACTIVITY_BACKUP: 'WL_PRESENTATION_ACTIVITY_BACKUP',
};

export const WL_RESOURCES = Object.entries(WL_RESOURCE_IDS).reduce(
  (obj, [key, value]) => {
    obj[key] = value;
    obj[key.replace('_ACTIVITY', '_CH')] = value.replace('_ACTIVITY', '_CH');
    obj[key.replace('_ACTIVITY', '_DE')] = value.replace('_ACTIVITY', '_DE');
    return obj;
  },
  {},
);

export const ResourceContentTypes = Object.freeze({
  PDF: 'PDF',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  PROFESSIONAL_LINK: 'PROFESSIONAL_LINK',
  ...WL_RESOURCES,
});

export const TABLE_SORT_MAP = Object.freeze({
  unit_ascending: 'unit_asc',
  unit_descending: 'unit_desc',
  topic_ascending: 'topic_asc',
  topic_descending: 'topic_desc',
  skill_ascending: 'skills_asc',
  skill_descending: 'skills_desc',
  taskmodel_ascending: 'task_model_asc',
  taskmodel_descending: 'task_model_desc',
  title_ascending: 'title_asc',
  title_descending: 'title_desc',
  proficiencies_ascending: 'proficiencies_asc',
  proficiencies_descending: 'proficiencies_desc',
  proficiency_ascending: 'proficiency_asc',
  proficiency_descending: 'proficiency_desc',
  bigidea_ascending: 'big_idea_asc',
  bigidea_descending: 'big_idea_desc',
  requiredcomponent_ascending: 'required_component_asc',
  requiredcomponent_descending: 'required_component_desc',
});

export const JSTOR_RESOURCE_DOMAIN = 'jstor.org';
